// Angular Modules
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { MessageModule } from 'primeng/message';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CarouselModule } from "primeng/carousel";
import { TooltipModule } from "primeng/tooltip";
import { AccordionModule } from "primeng/accordion";
import { TieredMenuModule } from "primeng/tieredmenu";
import { BadgeModule } from "primeng/badge";
import { DialogModule } from "primeng/dialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { InputSwitchModule } from "primeng/inputswitch";
import { RippleModule } from "primeng/ripple";
import { InputTextareaModule } from "primeng/inputtextarea";
import { InputTextModule } from "primeng/inputtext";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { InputNumberModule } from "primeng/inputnumber";
import { SelectButtonModule } from "primeng/selectbutton";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { MenuModule } from "primeng/menu";
import { PanelModule } from "primeng/panel";
import { MessagesModule } from "primeng/messages";
import { ChipModule } from "primeng/chip";
import { ChipsModule } from "primeng/chips";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GMapModule } from 'primeng/gmap';

// Feature Modules
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from "ng/src/app/core/core.module";
import { ChoiceListModule } from "ng/src/app/choice-lists/choice-list.module";
import { UsersModule } from "ng/src/app/users/users.module";
import { TagsModule } from "ng/src/app/tags/tags.module";
import { FilesModule } from "ng/src/app/files/files.module";

// Components
import { ReminderTickerComponent } from "../reminders/reminder-ticker.component";
import { ReminderCardComponent } from "../reminders/reminder-card.component";
import { FileAttachmentListComponent } from './shared/file-attachments/file-attachment-list.component';
import { DraftNotesComponent } from "./draft-notes/draft-notes.component";
import { SignoffControlsComponent } from "ng/src/app/notes/signoffs/signoff-controls.component";
import { NoteAcknowledgementsComponent } from './note-acknowledgements/note-acknowledgements.component';
import { NoteStatusIndicatorComponent } from 'ng/src/app/notes/nsi-indicator/note-status-indicator.component';
import { NotesTableComponent } from './notes-table/notes-table.component';
import { NotesTableCaptionComponent } from './notes-table/notes-table-caption.component';
import { NoteCommentComponent } from "ng/src/app/notes/note-comment/note-comment.component";
import { NoteEntryComponent } from "ng/src/app/notes/note-entry/note-entry.component";
import { NoteEntryControlsComponent } from "ng/src/app/notes/note-entry-controls/note-entry-controls.component";
import { NoteEntryTocComponent } from "./note-entry-toc/note-entry-toc.component";
import { NoteDetailComponent } from './note-detail/note-detail.component';
import { NoteLocationMapComponent } from './shared/note-location-map/note-location-map.component';
import { PastValuesComponent } from "ng/src/app/notes/past-values/past-values.component";
import { SplitButtonModule } from "primeng/splitbutton";
import { ChartModule } from "primeng/chart";
import { PastValueViewerComponent } from "ng/src/app/notes/past-values/past-value-viewer/past-value-viewer.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { NoteDisplayComponent } from "ng/src/app/notes/note-display/note-display.component";
import { NoteActionsComponent } from "ng/src/app/notes/note-actions/note-actions.component";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { EnterNotesComponent } from "ng/src/app/notes/enter-notes/enter-notes.component";
import { ShiftModule } from "ng/src/app/shifts/shift.module";
import { NoteControllerComponent } from "ng/src/app/notes/note-controller/note-controller.component";
import { BrowserModule } from "@angular/platform-browser";

@NgModule({
	declarations: [
		NotesTableComponent,
		NotesTableCaptionComponent,
		NoteAcknowledgementsComponent,
		NoteStatusIndicatorComponent,
		FileAttachmentListComponent,
		ReminderTickerComponent,
		ReminderCardComponent,
		DraftNotesComponent,
		SignoffControlsComponent,
		NoteEntryComponent,
		NoteEntryTocComponent,
		NoteCommentComponent,
		NoteDetailComponent,
		NoteEntryControlsComponent,
		NoteLocationMapComponent,
		PastValuesComponent,
		PastValueViewerComponent,
		NoteDisplayComponent,
		NoteActionsComponent,
		EnterNotesComponent,
		NoteControllerComponent
	],
	exports: [
		PastValuesComponent,
		NoteDisplayComponent,
		NoteActionsComponent,
		NoteControllerComponent
	],
	imports: [
		SharedModule,
		CommonModule,
		ReactiveFormsModule,
		TableModule,
		CheckboxModule,
		TriStateCheckboxModule,
		FormsModule,
		ButtonModule,
		OverlayPanelModule,
		DropdownModule,
		MessageModule,
		CardModule,
		DividerModule,
		CarouselModule,
		TooltipModule,
		TieredMenuModule,
		AccordionModule,
		BadgeModule,
		DialogModule,
		ConfirmPopupModule,
		CalendarModule,
		InputSwitchModule,
		RippleModule,
		InputTextareaModule,
		InputTextModule,
		TreeModule,
		TreeTableModule,
		InputNumberModule,
		UsersModule,
		SelectButtonModule,
		ChoiceListModule,
		CoreModule,
		BreadcrumbModule,
		MenuModule,
		FilesModule,
		PanelModule,
		MessagesModule,
		RadioButtonModule,
		ChipModule,
		TagsModule,
		ChipsModule,
		ConfirmDialogModule,
		GMapModule,
		SplitButtonModule,
		ChartModule,
		ProgressSpinnerModule,
		DynamicDialogModule,
		ShiftModule
	]
})
export class NoteModule { }